export default [
  {
    header: 'others.content_manager',
    resource: ['content_manager'],
    permission: ['admin', 'accountant'],
  },
  {
    title: 'others.content_base',
    route: 'content-base',
    icon: 'DatabaseIcon',
    resource: ['content_manager'],
    permission: ['admin', 'accountant'],
  },
]
